<template>
  <div class="page">
    <nav class="nav-bar">
      <NavBar />
    </nav>
    <div class="marginCenter">
      <router-view />
    </div>
  </div>
</template>
<script>
import NavBar from "@/views/components/navBar";
export default {
  components: {
    NavBar,
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped></style>
